import React, { Fragment, useEffect, useState } from "react";
import { LiHandleButton } from "../../Utils/CustomComponent";
import { lenderAchInformationProfilePageArr } from "../LenderOnboarding/LenderACHInformation/LenderAchConstants";
import MultipleFormBoxComp from "../../components/FormBox/MultipleFormBoxComp";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import useBorrowerProfile from "../../hooks/useBorrowerProfile";

const ProfileForBorrower = ({ tinType }) => {
  const accountId = useSelector((state) => state.account.lenderId);
  const profileInfo = useBorrowerProfile(accountId);
  const selectedRoleLabel = useSelector(
    (state) => state.account.selectedRole.label
  );
  const [activeTab, setActiveTab] = useState(0);
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "all" });

  useEffect(() => {
    Object.keys(profileInfo?.general)?.forEach((key) => {
      setValue(key, profileInfo.general[key]);
    });
    Object.keys(profileInfo?.ach)?.forEach((key) => {
      setValue(key, profileInfo.ach[key]);
    });
  }, [setValue, profileInfo?.general?.EmailAddress]);

  return (
    <div>
      <div
        className="d-flex"
        style={{ justifyContent: "space-between", alignItems: "end" }}
      >
        <h4 className="mt-5 pt-5">Borrower ACH Information</h4>
      </div>
      <div className="loan-details lender-ach-form">
        <div className="pt-3">
          <ul className="nav nav-tabs">
            {tabButtons.map((data, index) => (
              <LiHandleButton
                key={index}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                label={data.label}
                value={index}
                handleBtnClick={setActiveTab}
              />
            ))}
          </ul>
        </div>
      </div>
      <form>
        <div className="loans-in-details mt-5">
          {lenderAchInformationProfilePageArr(false, 0, selectedRoleLabel).map(
            (data, index) =>
              activeTab === index && (
                <Fragment key={index}>
                  <MultipleFormBoxComp
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    options={data.arr}
                    errors={errors}
                  />
                </Fragment>
              )
          )}
          <div className="col-sm-12 d-flex justify-content-between">
            {activeTab > 0 && (
              <Button
                onClick={() => setActiveTab(activeTab - 1)}
                className="me-2"
              >
                Back
              </Button>
            )}
            {activeTab < 1 && (
              <Button
                onClick={() => setActiveTab(activeTab + 1)}
                className="me-2"
              >
                Next
              </Button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default ProfileForBorrower;

const tabButtons = [
  { label: <p>General</p> },
  // { label: <p>Details</p> },
  { label: <p>ACH</p> },
];
